"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ListDataVerticalSteps_1 = __importDefault(require("./ListDataVerticalSteps"));
require("./VerticalStepsComponent.scss");
const exampleStepsArray = [
    {
        completed: true,
        name: 'Name & Description',
        disabled: false
    },
    {
        completed: false,
        name: 'Members',
        disabled: true
    },
    {
        completed: false,
        name: 'Configuration',
        disabled: true
    },
    {
        completed: false,
        name: 'Verify',
        disabled: true
    }
];
const VerticalStepsComponent = ({ steps = exampleStepsArray, activeStep = 'Members', setActiveStep }) => {
    return (react_1.default.createElement("div", { className: "vertical-steps-container" }, steps.map((step, index) => (react_1.default.createElement(ListDataVerticalSteps_1.default, { steps: steps, step: step, index: index, key: index, activeStep: activeStep, setActiveStep: setActiveStep })))));
};
exports.default = VerticalStepsComponent;
